import { createContext, useContext, useMemo, useState } from "react";

export type OrderTypeFilter = "b2c" | "b2b" | "all";

interface Filters {
  periodeStart: string; // YYYY-MM-DD
  periodeEnd: string;
  kanaal: string | null;
  orderType: OrderTypeFilter;
  setPeriode: (start: string, end: string) => void;
  setKanaal: (kanaal: string | null) => void;
  setOrderType: (t: OrderTypeFilter) => void;
}

const FilterContext = createContext<Filters | null>(null);

function defaultPeriode(): [string, string] {
  const today = new Date();
  const fmt = (d: Date) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  const t = fmt(today);
  return [t, t];
}

export function FilterProvider({ children }: { children: React.ReactNode }) {
  const [start, defaultEnd] = defaultPeriode();
  const [periodeStart, setStart] = useState(start);
  const [periodeEnd, setEnd] = useState(defaultEnd);
  const [kanaal, setKanaalState] = useState<string | null>(null);
  const [orderType, setOrderTypeState] = useState<OrderTypeFilter>("all");

  const value = useMemo<Filters>(
    () => ({
      periodeStart,
      periodeEnd,
      kanaal,
      orderType,
      setPeriode: (s, e) => {
        setStart(s);
        setEnd(e);
      },
      setKanaal: setKanaalState,
      setOrderType: setOrderTypeState,
    }),
    [periodeStart, periodeEnd, kanaal, orderType],
  );

  return <FilterContext.Provider value={value}>{children}</FilterContext.Provider>;
}

export function useFilters() {
  const ctx = useContext(FilterContext);
  if (!ctx) throw new Error("useFilters must be used within FilterProvider");
  return ctx;
}
